import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import cartReducer from './reducers/cartSlice';

// Core reducers
import {
	loadingIndicatorReducer,
	feedbackToastReducer,
	patientRegisterReducer,
	patientAuthReducer,
	patientGoogleAuthReducer,
	patientPasswordReducer,
	patientDataReducer,
	patientCaptchaReducer,
	patientProfileCompletionReducer,
	patientTreatmentRecordsReducer,
	patientGenerateKeyReducer,
	categoriesReducer,
	drugsReducer,
	// drugByIdReducer,
	drugUploadReducer,
	ordersReducer,
	orderItemsReducer,
	gptReducer,
	mpesaReducer,
	cartSlice,
	pharmacyRegisterReducer,
	pharmacyLoginReducer,
	pharmacyPasswordReducer,
	pharmacyVerificationReducer,
	pharmacyCaptchaReducer,
	pharmacyGoogleAuthReducer,
	pharmacyProfileReducer,
	modalReducer,
	hospitalRegisterReducer,
	hospitalLoginReducer,
	hospitalPasswordReducer,
	hospitalVerificationReducer,
	hospitalCaptchaReducer,
	hospitalGoogleAuthReducer,
	hospitalmodalReducer,
	hospitalDataReducer,
	hospitalTreatmentReducer,
	hospitalGenerateKeyReducer,
	hospitalProfileReducer,
	// Doctor reducers
	doctorRegisterReducer,
	doctorLoginReducer,
	doctorGoogleAuthReducer,
	doctorCaptchaReducer,
	doctorVerificationReducer,
	doctorPasswordReducer,
} from './reducers';
import doctorProfileReducer from './reducers/user/doctor/profile';
// Medichat reducers (from first file)
import webSocketReducer from './reducers/medichat/websocket/websocketReducer';
import postsReducer from './reducers/medichat/feed/posts';
import groupsReducer from './reducers/medichat/groups/groups';
import commentsReducer from './reducers/medichat/feed/comments';

import { subscriptionMiddleware } from './middleware/subscription';

const store = configureStore({
	reducer: {
		// Global reducers
		showLoading: loadingIndicatorReducer,
		feedback: feedbackToastReducer,
		patientRegister: patientRegisterReducer,
		patientAuth: patientAuthReducer,
		patientGoogleAuth: patientGoogleAuthReducer,
		patientPassword: patientPasswordReducer,
		patientCaptcha: patientCaptchaReducer,
		patientProfileCompletion: patientProfileCompletionReducer,
		patientData: patientDataReducer,
		patientTreatmentRecords: patientTreatmentRecordsReducer,
		patientGenerateKey: patientGenerateKeyReducer,
		drugs: drugsReducer,
		// drugById: drugByIdReducer,
		drugUpload: drugUploadReducer,
		categories: categoriesReducer,
		cart: cartSlice,
		gpt: gptReducer,
		orders: ordersReducer,
		orderItems: orderItemsReducer,
		mpesaTransaction: mpesaReducer,

		// Pharmacy reducers
		pharmacyRegister: pharmacyRegisterReducer,
		pharmacyLogin: pharmacyLoginReducer,
		pharmacyPassword: pharmacyPasswordReducer,
		pharmacyVerification: pharmacyVerificationReducer,
		pharmacyCaptcha: pharmacyCaptchaReducer,
		pharmacyGoogleAuth: pharmacyGoogleAuthReducer,
		pharmacyProfile: pharmacyProfileReducer,

		// Hospital reducers
		hospitalRegister: hospitalRegisterReducer,
		hospitalAuth: hospitalLoginReducer,
		hospitalPassword: hospitalPasswordReducer,
		hospitalVerification: hospitalVerificationReducer,
		hospitalCaptcha: hospitalCaptchaReducer,
		hospitalGoogleAuth: hospitalGoogleAuthReducer,
		hospitalModal: hospitalmodalReducer,
		hospitalData: hospitalDataReducer,
		hospitalProfile: hospitalProfileReducer,
		hospitalTreatmentRecords: hospitalTreatmentReducer,
		hospitalGenerateKey: hospitalGenerateKeyReducer,

		// Doctor reducers
		doctorRegister: doctorRegisterReducer,
		doctorLogin: doctorLoginReducer,
		doctorGoogleAuth: doctorGoogleAuthReducer,
		doctorCaptcha: doctorCaptchaReducer,
		doctorVerification: doctorVerificationReducer,
		doctorPassword: doctorPasswordReducer,
		doctorProfile: doctorProfileReducer,

		// Medichat reducers
		posts: postsReducer,
		comments: commentsReducer,
		groups: groupsReducer,
		webSocket: webSocketReducer,
		webSocketMessage: webSocketReducer,
		webSocketConnection: webSocketReducer,

		// Global modal (used by some modules)
		modal: modalReducer,
	},
	preloadedState: {},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(thunk, subscriptionMiddleware),
});

export default store;
